import { automationRuleDependencies } from 'modules/automation-rules/constants/automation-rule-dependencies'
import { AutomationRuleApiInterface } from 'modules/automation-rules/types/automation-rule-interface'
import { FUNNEL_STEP_API } from 'modules/funnels/funnel/api/funnel-api'
import { FunnelStepId } from 'modules/funnels/funnel/types/funnel-step-interface'
import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'

export const useFunnelStepRules = (funnelStepId?: FunnelStepId) => {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, AutomationRuleApiInterface>({
    method: RequestMethodsEnum.get,
  })

  return useControlledSwr(() => {
    if (!user || !funnelStepId) return
    return [`${FUNNEL_STEP_API}/${funnelStepId}/automation-rules`, ...automationRuleDependencies]
  }, fetcher)
}
